/* ----------------------------------------------------------------
   Kushface - Cart drawer
   AJAX cart over Shopify /cart/*.js. Vanilla, no deps. Exposes
   window.kfCart {add, open, close, refresh}. Any [data-add-to-cart]
   [data-variant-id] element adds; [data-cart-toggle] opens;
   [data-cart-close] closes. Respects prefers-reduced-motion via CSS.
   ---------------------------------------------------------------- */

(function () {
  "use strict";

  var root = document.querySelector("[data-cart]");
  if (!root) return;

  var body = root.querySelector("[data-cart-body]");
  var skel = body && body.querySelector(".kf-skel");
  var foot = root.querySelector("[data-cart-foot]");
  var subtotalEl = root.querySelector("[data-cart-subtotal]");
  var panel = root.querySelector(".kf-cart__panel");
  var lastFocused = null;

  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(data)
    }).then(function (r) {
      if (!r.ok) throw new Error("Cart request failed");
      return r.json();
    });
  }

  function getCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).then(function (r) {
      if (!r.ok) throw new Error("Cart fetch failed");
      return r.json();
    });
  }

  function makeIconButton(label, pathD, cls, attrs) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = cls;
    btn.setAttribute("aria-label", label);
    Object.keys(attrs || {}).forEach(function (k) {
      btn.setAttribute(k, attrs[k]);
    });
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 16 16");
    svg.setAttribute("width", "16");
    svg.setAttribute("height", "16");
    svg.setAttribute("fill", "none");
    svg.setAttribute("aria-hidden", "true");
    var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", pathD);
    p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "1.5");
    p.setAttribute("stroke-linecap", "square");
    svg.appendChild(p);
    btn.appendChild(svg);
    return btn;
  }

  function buildItem(item) {
    var row = document.createElement("div");
    row.className = "kf-cart__item";
    row.setAttribute("data-key", item.key);

    var thumb = document.createElement("a");
    thumb.className = "kf-cart__thumb";
    thumb.href = item.url;
    if (item.image) {
      var img = document.createElement("img");
      img.src = item.image;
      img.alt = item.product_title || "";
      img.loading = "lazy";
      thumb.appendChild(img);
    }

    var info = document.createElement("div");
    info.className = "kf-cart__info";

    var name = document.createElement("a");
    name.className = "kf-cart__name";
    name.href = item.url;
    name.textContent = item.product_title || item.title || "";

    var price = document.createElement("p");
    price.className = "kf-cart__price kf-mono";
    price.textContent = formatMoney(item.final_line_price);

    var qty = document.createElement("div");
    qty.className = "kf-cart__qty";
    var dec = document.createElement("button");
    dec.type = "button";
    dec.setAttribute("data-qty-dec", "");
    dec.setAttribute("aria-label", "Decrease quantity");
    dec.textContent = "-";
    var count = document.createElement("span");
    count.setAttribute("data-qty", "");
    count.textContent = String(item.quantity);
    var inc = document.createElement("button");
    inc.type = "button";
    inc.setAttribute("data-qty-inc", "");
    inc.setAttribute("aria-label", "Increase quantity");
    inc.textContent = "+";
    qty.appendChild(dec);
    qty.appendChild(count);
    qty.appendChild(inc);

    info.appendChild(name);
    info.appendChild(price);
    info.appendChild(qty);

    var remove = makeIconButton(
      "Remove item",
      "M3 3l10 10M13 3L3 13",
      "kf-cart__remove",
      { "data-remove": "" }
    );

    row.appendChild(thumb);
    row.appendChild(info);
    row.appendChild(remove);
    return row;
  }

  function updateCartBadge(cart) {
    var n = cart && cart.item_count ? cart.item_count : 0;
    var badges = document.querySelectorAll("[data-cart-count]");
    Array.prototype.forEach.call(badges, function (el) {
      el.textContent = String(n);
      if (n > 0) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });
  }

  function clearItems() {
    var node = body.lastChild;
    while (node) {
      var prev = node.previousSibling;
      if (node !== skel) body.removeChild(node);
      node = prev;
    }
  }

  function setLoading(on) {
    if (!skel) return;
    body.classList.toggle("is-loading", !!on);
  }

  function render(cart) {
    updateCartBadge(cart);
    clearItems();
    if (!cart || !cart.items || cart.items.length === 0) {
      var empty = document.createElement("p");
      empty.className = "kf-cart__empty kf-display kf-display--lg";
      empty.textContent = "NO SMILES YET.";
      body.appendChild(empty);
      foot.setAttribute("hidden", "");
      return;
    }
    cart.items.forEach(function (item) {
      body.appendChild(buildItem(item));
    });
    subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    foot.removeAttribute("hidden");
  }

  function refresh() {
    setLoading(true);
    return getCart()
      .then(function (cart) {
        render(cart);
        setLoading(false);
      })
      .catch(function () {
        /* fail soft - leave existing drawer state */
        setLoading(false);
      });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    root.classList.add("is-open");
    if (panel) panel.focus();
  }

  function closeDrawer() {
    root.classList.remove("is-open");
    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus();
    }
  }

  function add(variantId, quantity) {
    var id = Number(variantId);
    if (!id) return Promise.resolve();
    return postJSON("/cart/add.js", { items: [{ id: id, quantity: quantity || 1 }] })
      .then(refresh)
      .then(openDrawer)
      .catch(function () {
        /* fail soft - no console noise in production */
      });
  }

  function changeByKey(key, quantity) {
    setLoading(true);
    return postJSON("/cart/change.js", { id: key, quantity: quantity })
      .then(function (cart) {
        render(cart);
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }

  document.addEventListener("click", function (e) {
    var addBtn = e.target.closest("[data-add-to-cart][data-variant-id]");
    if (addBtn) {
      e.preventDefault();
      add(addBtn.getAttribute("data-variant-id"), 1);
      return;
    }
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      refresh().then(openDrawer);
      return;
    }
    if (e.target.closest("[data-cart-close]")) {
      closeDrawer();
      return;
    }

    var row = e.target.closest(".kf-cart__item");
    if (!row) return;
    var key = row.getAttribute("data-key");
    var current = parseInt(
      row.querySelector("[data-qty]") && row.querySelector("[data-qty]").textContent,
      10
    ) || 1;

    if (e.target.closest("[data-qty-inc]")) {
      changeByKey(key, current + 1);
    } else if (e.target.closest("[data-qty-dec]")) {
      changeByKey(key, Math.max(0, current - 1));
    } else if (e.target.closest("[data-remove]")) {
      changeByKey(key, 0);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  window.kfCart = {
    add: add,
    open: function () { return refresh().then(openDrawer); },
    close: closeDrawer,
    refresh: refresh
  };
})();
